"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class DeleteHardbounces {
    static getAttributeTypeMap() {
        return DeleteHardbounces.attributeTypeMap;
    }
}
DeleteHardbounces.discriminator = undefined;
DeleteHardbounces.attributeTypeMap = [
    {
        "name": "startDate",
        "baseName": "startDate",
        "type": "string"
    },
    {
        "name": "endDate",
        "baseName": "endDate",
        "type": "string"
    },
    {
        "name": "contactEmail",
        "baseName": "contactEmail",
        "type": "string"
    }
];
exports.DeleteHardbounces = DeleteHardbounces;
//# sourceMappingURL=deleteHardbounces.js.map